import API from '@/api'
import router from '@/router'

export default {
  namespaced: true,

  state: {
    data: {},

    template: {
      dripDataPh: 0,
      dripDataEc: 0,
      drainageDataPh: 0,
      drainageDataEc: 0,
      drainagePercentage: null,
      drainageVolume: null,
      dripVolume: null,
      cropId: null,
      varietyId: null,
      growingMethodId: null,
      yieldGoalId: null,
      stageId: null,
      programId: null,
      name: '',
      data: [],
      sampling_date: ''
    },

    filter: {
      page: 1,
      search: '',
      take: 999
    },

    waterTests: [],

    drainages: [],
    programs: [],

    isEditing: false,
    loadingSVG: false,
    drainageLoad: false
  },

  mutations: {
    setSearch(state, val) {
      state.filter.search = val;
    },
    // setOpen (state, flag) {
    //   state.open = flag;
    // },
    saveCropInfo(state, data) {
      state.data.cropId = data.cropId;
      state.data.varietyId = data.varietyId;
      state.data.growingMethodId = data.growingMethodId;
      state.data.yieldGoalId = data.yieldGoalId;
      state.data.stageId = data.stageId;
    },
    dropCropInfo(state) {
      state.data.cropId = 0;
      state.data.varietyId = 0;
      state.data.growingMethodId = 0;
      state.data.yieldGoalId = 0;
      state.data.stageId = 0;
    },

    setEditing(state, edit) {
      state.isEditing = edit;
    },

    saveData(state, data) {
      state.data = data;
    },

    saveWatertests(state, data) {
      state.waterTests = data;
    },
    setWaterTestId(state, data) {
      state.data.waterTestId = data;
    },
    setProgramId(state, data) {
      state.data.programId = data;
    },

    setDrainagePercentage(state, data) {
      state.data.drainagePercentage = data
    },

    setNutrients(state, data) {
      state.data.data = data
    },

    setValue(state, data) {
      state.data.data.find(e => e.Element == data.Element)[data.i] = data.val
    },

    loadData(state, getters, id) {
      state.data = state.drainages.find(el => el.drainageId == id)
    },

    setUserDrainages(state, data) {
      state.drainages.splice(0, state.drainages.length)
      data.forEach(e => {
        e.drainageId = e.id
        delete e.id
        delete e.usetId
        delete e.request
        delete e.result
        delete e.updated_at;
      })
      state.drainages = data;
    },

    setPrograms(state, data) {
      state.programs = data;
    },

    setSVGLoading(state, loadingSVG) {
      state.loadingSVG = loadingSVG;
    },

    setDrainageLoading(state, drainageLoad) {
      state.drainageLoad = drainageLoad
    }
  },

  actions: {
    clean({commit, state}) {
      commit('saveData', 
      {
        name: '',
        drainageVolume: 0,
        dripVolume: 0,
        dripDataPh: 0,
        dripDataEc: 0,
        drainageDataPh: 0,
        drainageDataEc: 0,
        drainagePercentage: 0,
        cropId: 0,
        varietyId: 0,
        growingMethodId: 0,
        yieldGoalId: 0,
        stageId: 0,
        programId: 0,
        data: [],
      });
    },
    load({ commit, dispatch }, payload) {
      // TODO: load drainage by id

      commit('loadData', payload)
    },

    // loadWaterTests({commit}) {
    //   return API.drainage.loadWaterTests({ type: 'water-anal', take: 999, page: 0, search: ''})
    //     .then( res => {
    //       commit('saveWatertests', res.data.data);
    //     });
    // },

    saveDrainage( {commit, dispatch, state}, data ) { 
      return API.drainage.saveDrainage(data).then(res => {    

        dispatch('getUserDrainages').then(() => {
          router.push('/dashboard/drainage/' + res.data.data.id)
        })
        return res.data.data
      },rej => {
      }) 
    },

    updateDrainage( {commit, dispatch, state}, data ) {
      return API.drainage.updateDrainage(data).then(res => {
        return res.data.data
      })
    },

    deleteDrainage({state, dispatch}, drainageId) {
      return API.drainage.deleteDrainage(drainageId).then(res => {
        dispatch('clean')

        dispatch('getUserDrainages')
      })
    },

    getUserDrainages({state, commit}) {
      return API.drainage.getUserDrainages(state.filter).then( res => {
        commit('setUserDrainages', res.data.data)
      });
    },
    
    selectSingleDrainage({state, rootGetters, commit}, drainageId) {
      return API.drainage.selectSingleDrainage({drainageId: drainageId}).then(res => {
        res.data.data.drainageId = res.data.data.id

        delete res.data.data.request
        delete res.data.data.result
        delete res.data.data.created_at
        delete res.data.data.updated_at
        delete res.data.data.userId
        delete res.data.data.id;

        let data = JSON.parse(JSON.stringify(res.data.data))
        data.dripVolume = parseFloat(rootGetters['unit/convert']('mL', data.dripVolume)).toFixed(1)
        data.drainageVolume = parseFloat(rootGetters['unit/convert']('mL', data.drainageVolume)).toFixed(1)
        commit('saveData', data)
        return res.data.data
      })
    },

    findByStep({state, commit}, stageId) {
      return API.drainage.findByStep(stageId).then(res => {
        commit('setUserDrainages', res.data.data)
      })
    },

    getProgramsByCrop({state}) {
      return API.drainage.getProgramsByCrop({
        cropId: state.data.cropId,
        cropVarietyId: state.data.varietyId,
        cropGrowingMethodId: state.data.growingMethodId      
      })
    },
  },

  getters: {
    getNutrients(state) {
      let program, nuts
      // find program by id
      program = state.programs.find(e => e.id == state.data.programId)

        nuts = program ? JSON.parse(program.adjust.data).find(e => e.Properties.StageId == state.data.stageId).Nutrients : []
      
      return nuts
    },
    data(state) {
      return state.data;
    },
    template(state) {
      return state.template
    },
    drainages(state) {
      return state.drainages
    },
    programs(state) {
      return state.programs
    },
    waterTests(state) {
      return state.waterTests.map( el => {
        return {
          name: el.name,
          id: el.id,
        }
      });
    },

    isEditing(state) {
      return state.isEditing;
    },

    getSVGLoading(state) {
      return state.loadingSVG
    },

    drainageLoad(state) {
      return state.drainageLoad
    }

  }

}
